import { render, staticRenderFns } from "./DailySchedule.vue?vue&type=template&id=b5cdcdc4&"
import script from "./DailySchedule.vue?vue&type=script&lang=js&"
export * from "./DailySchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports